import Entities from 'STORE';

export function closeAudioPlayer(): void {
  Entities.miniAudioPlayer.reset();
}
